export default __webpack_public_path__ + "static/media/_0000_instrucciones.c69b3838.png";